<template>
	<section class="margin-both-lg container container--large" :class="typeClass" v-if="data">
		<template v-if="data && data.type === 'form' && data.picked_form">
			<transition name="opacity">
				<GravityFormPopup
					v-if="showForm"
					:title="data.popup_title || ''"
					:content="data.popup_description || ''"
					:form="Number(data.picked_form)"
					@close="formIsClosed"
				/>
			</transition>
			<a
				class="inner padding-lg"
				@click="popGrafityForm"
				@mouseover="isHovered = true"
				@mouseout="isHovered = false"
			>
				<h2 class="titler">{{ data.title }}</h2>
				<p class="description module-text margin-both" v-if="data.content" v-html="data.content"></p>
				<Button
					:outlined="false"
					:class="{ hover: isHovered }"
					:aria-label="data.popup_button || 'Kontakt oss'"
					class="button-cta"
					:type="buttonType"
				>
					<span v-html="data.popup_button || 'Kontakt oss'"></span>
				</Button>
			</a>
		</template>

		<template v-if="data && data.type === 'iframe' && data.iframe_link">
			<transition name="opacity">
				<iFramePopup
					v-if="showForm"
					:title="data.popup_title || ''"
					:content="data.popup_description || ''"
					:link="data.iframe_link"
					@close="formIsClosed"
				/>
			</transition>
			<a
				class="inner padding-lg"
				@click="popGrafityForm"
				@mouseover="isHovered = true"
				@mouseout="isHovered = false"
			>
				<h2 class="titler">{{ data.title }}</h2>
				<p class="description module-text margin-both" v-if="data.content" v-html="data.content"></p>
				<Button
					:outlined="false"
					:class="{ hover: isHovered }"
					:aria-label="data.popup_button || 'Kontakt oss'"
					class="button-cta"
					:type="buttonType"
				>
					<span v-html="data.popup_button || 'Kontakt oss'"></span>
				</Button>
			</a>
		</template>

		<template v-if="data && data.type === 'link'">
			<WpLink
				:url="data.link.url"
				:title="data.link.title"
				:target="data.link.target"
				@mouseover.native="isHovered = true"
				@mouseout.native="isHovered = false"
				class="inner padding-lg"
			>
				<h2 class="titler">{{ data.title }}</h2>
				<p class="description module-text margin-both" v-if="data.content" v-html="data.content"></p>
				<Button
					:outlined="false"
					:class="{ hover: isHovered }"
					:aria-label="data.link.title"
					class="button-cta"
					:type="buttonType"
				>
					<span v-html="data.link.title"></span>
				</Button>
			</WpLink>
		</template>
	</section>
</template>

<script>
import Button from '@/components/elements/Button'
import WpLink from '@/components/elements/WpLink'
import GravityFormPopup from '@/components/parts/GravityFormPopup'
import iFramePopup from '@/components/parts/iFramePopup'

export default {
	name: 'call-to-action',
	props: ['data'],
	data() {
		return {
			isHovered: false,
			showForm: false,
			allowReopenPopup: true,
		}
	},
	mounted() {},
	components: {
		Button,
		WpLink,
		GravityFormPopup,
		iFramePopup,
	},
	computed: {
		buttonType() {
			return this.data.color && this.data.color.name === 'red' ? 'white' : 'red'
		},
		typeClass() {
			let classes = []
			if (this.data.color) classes.push('color-' + this.data.color.name)
			return classes.splice(' ')
		},
	},
	methods: {
		popGrafityForm() {
			if (this.allowReopenPopup) {
				this.showForm = true
				this.allowReopenPopup = false
			}
		},
		formIsClosed() {
			this.showForm = false
			setTimeout(() => {
				this.allowReopenPopup = true
			}, 400)
		},
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';
@import '@/assets/extends.scss';
.module-call_to_action {
	text-align: center;
	.form-title {
		@include fluid-type($smallResText, $wideResText, 22px, 30px);
	}
	.inner {
		border-radius: $blocksRadius;
		padding-left: 15px;
		padding-right: 15px;
		display: block;
		cursor: pointer;
		color: var(--light);
		background-color: var(--dark);
		text-decoration: none;
		transition: 0.2s box-shadow ease-in-out, 0.15s color ease-in-out;
		.description {
			max-width: 800px;
			margin-left: auto;
			margin-right: auto;
			font-weight: 400;
			@include fluid-type($smallResText, $wideResText, 16px, 22px);
		}
		.button-cta {
			margin-top: 10px;
			@include mquery($tablet) {
				margin-top: 5px;
			}
		}
		.titler {
			font-weight: 400;
			margin-bottom: 20px;
			margin-top: 0;
		}
		&:hover {
			background-color: var(--dark);
		}
	}
	&.color-white {
		.inner {
			color: var(--dark);
			background-color: var(--light);
		}
	}
	&.color-red {
		.inner {
			background-color: $red;
		}
	}
}
</style>
